module.exports = __webpack_public_path__ + "976a5c306f24c2e064eb500b312a7e63.png";